import { OfflinePlatform } from "@linkfluence/models/platform";
import { InfluencerLens } from "./generic";
import {
  Audience,
  GenericInfluencer,
  Geo,
  InfluencerAccountMetric,
  SocialAccount,
} from ".";

export interface OfflineInfluencer extends GenericInfluencer<OfflinePlatform> {
  idStr: string;
  geo: Geo;
  audience: Audience;
  name: string;
  id: string;
  socialAccount: SocialAccount;
  profileImg: string;
  lang: any;
  email: string[];
}

export class OfflineInfluencerLens extends InfluencerLens<OfflineInfluencer> {
  public getAvatar(): string {
    return this.influencer.profileImg;
  }
  public getCountry(): string {
    return this.influencer.geo.country;
  }
  public getAccountMetrics(): InfluencerAccountMetric[] {
    return [
      {
        key: "AVERAGE_TRAFFIC",
        value: this.influencer.audience.meanTraffic,
      },
      { key: "COUNTRY", value: this.influencer.geo.country },
    ];
  }
  public getQuery(): string {
    return `offline-media.id:${this.influencer.id}`;
  }
}
